module.exports = __webpack_public_path__ + "img/librarybg3.6403f934.png";